import { render, staticRenderFns } from "./EditKitSidePanel.vue?vue&type=template&id=f833f1d2&scoped=true&"
import script from "./EditKitSidePanel.vue?vue&type=script&lang=ts&"
export * from "./EditKitSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f833f1d2",
  null
  
)

export default component.exports